import React, { memo, useCallback } from 'react';

import { Box, FormControlLabel, Switch } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { loanManagementTestIds } from '../../loanManagement.testIds';
import useFormContext from '../hooks/useFormContext';
import { DynamicValueInput } from '../LoanActionItems';

import { wrapperStyles } from './LoanActionDuplicatePolicyRow.styles';

const LoanActionDuplicatePolicyRow = ({
  index,
  rootPath,
  isDisabled,
  isEditAllowed,
  duplicatePolicyOptions,
}) => {
  const { form, setInForm } = useFormContext();

  const formKey = `${rootPath}[${index}]`;
  const duplicatePolicyPath = `${formKey}.duplicatePolicy`;
  const sendNotificationPath = `${formKey}.sendNotification`;

  const sendNotification = _.get(form, sendNotificationPath) ?? true;
  const areFieldsDisabled = isDisabled || !isEditAllowed;

  const onToggleSendNotification = useCallback(() => {
    setInForm(sendNotificationPath, !sendNotification);
  }, [sendNotificationPath, sendNotification, setInForm]);

  return (
    <Box sx={wrapperStyles}>
      <DynamicValueInput
        required
        className="grow"
        disabled={areFieldsDisabled}
        label="Duplicate Policy"
        name={duplicatePolicyPath}
        options={duplicatePolicyOptions}
        type={FieldTypesEnum.SELECT}
      />
      <FormControlLabel
        control={
          <Switch
            checked={sendNotification}
            disabled={areFieldsDisabled}
            onChange={onToggleSendNotification}
          />
        }
        data-testid={loanManagementTestIds.getSendNotificationSwitchId(formKey)}
        label="Send Notification"
      />
    </Box>
  );
};

LoanActionDuplicatePolicyRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  duplicatePolicyOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default memo(LoanActionDuplicatePolicyRow);
